/**
 * SPDX-License-Identifier: MPL-2.0
 * Copyright 2024 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2024 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2024 (c) Daniel Littfinski, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2024-2025 (c) Marc Fischer, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import { useAuth } from 'Contexts/Auth';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { RootState } from '../index';
import { Dispatch } from '@reduxjs/toolkit';
import { CompanyDataActions } from 'CompanyData/CompanyDataActions';
import { Button, Form, Row } from 'react-bootstrap';
import Col from 'react-bootstrap/Col';
import Api from 'Api/Api';

type StateProps_t = ReturnType<typeof mapStateToProps>;
type DispatchProps_t = ReturnType<typeof mapDispatchToProps>;
type CompanyDataProps = StateProps_t & DispatchProps_t;

const Me = ({ companies, QueryCompanys }: CompanyDataProps) => {
  const auth = useAuth();

  // All company data from DB
  useEffect(() => {
    QueryCompanys();
  }, [QueryCompanys]);

  const [result, setResult] = useState<string | undefined>(undefined);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    e.stopPropagation();
    const target = e.target as typeof e.target & {
      password: { value: string };
      password_retype: { value: string };
    };
    if (target.password.value !== target.password_retype.value) {
      setResult('Error: Passwords are not equal');
      return;
    }
    Api.Me.changeSelf(target.password.value)
      .then(() => {
        setResult('OK: Changed password');
      })
      .catch((res) => {
        var errors = JSON.parse(res.request?.responseText || '{}');
        errors = errors.map((e: any) => e?.Description);
        setResult('Error:' + errors.join('', ''));
      });
  };

  return (
    <div>
      <p>
        <strong>Username:</strong> {auth.user?.Username}
      </p>
      <p>
        <strong>Related companies:</strong>{' '}
        {auth.user?.CompanyIds?.map((id) => companies.find((el) => el.Id === id)?.Name).join(', ')}
      </p>
      <p>
        <strong>User ID:</strong> {auth.user?.Id}
      </p>
      <p>
        <strong>Roles:</strong> {auth.user?.Roles?.join(', ')}
      </p>
      <p>
        <strong>ClientName:</strong> {auth.user?.ClientName}
      </p>
      <Form onSubmit={handleSubmit}>
        <Row className="mb-3">
          <Form.Group as={Col} md="4" controlId="validationCustom01">
            <Form.Label>Password</Form.Label>
            <Form.Control required type="password" placeholder="Your password" name="password" />
            <Form.Label>Retype password</Form.Label>
            <Form.Control required type="password" placeholder="Your password" name="password_retype" />
          </Form.Group>
        </Row>
        <Button type="submit">Reset password</Button>
        <div>{result}</div>
      </Form>
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    companies: state.companies.Companies,
    querying: state.companies.Querying,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    QueryCompanys: () => CompanyDataActions.QueryCompanys()(dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Me);
